import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { UtilServico } from 'src/app/servicos/util.servico';
import { UtilDadosLogado } from 'src/app/servicos/util.logado';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';
import { TransmissaoA1Service } from 'src/app/servicos/transmissao-a1.service';

@Component({
  selector: 'app-s1020',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './s1020.component.html',
  styleUrls: ['./s1020.component.scss']
})
export class S1020Component implements OnInit {
  Form: FormGroup;
  dados: any = {};
  loandTransmissao: boolean = false;
  usuario_id: any;
  db_config: any;
  tipo_assinatura: any;
  CarregandoLine: boolean = false;



  validacao_mensagens = {
    tipo: [{ type: 'required', message: 'Tipo é requerido' }]
  };

  constructor(
    private transmite: TransmissaoA1Service,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<S1020Component>,
    private utilServico: UtilServico,
    private utilDadosLogado: UtilDadosLogado,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public dados2: any
  ) {
    this.Form = fb.group({
      tipo: [null, Validators.required],
      iniValid: [null, Validators.required],
      fimValid: [null, Validators.required]
    });
  }

  ngOnInit() {

    const { usuario_id, db_config, tipo_assinatura } = this.utilDadosLogado.DadosAcesso();

    this.usuario_id = usuario_id;
    this.db_config = db_config;
    this.tipo_assinatura = tipo_assinatura;

    this.dados.tipo = this.dados2.tipo;
    this.dados.iniValid = '07/2021';
    this.dados.fimValid =
      (new Date().getMonth() + 1).toString().length < 2
        ? '0' + (new Date().getMonth() + 1).toString() + '/' + new Date().getFullYear().toString()
        : (new Date().getMonth() + 1).toString() + '/' + new Date().getFullYear().toString();
  }

  Validaform() {
    if (this.dados.tipo === null) return false;
    if (this.dados.iniValid === null) return false;
    if (this.dados.fimValid === null) return false;
    return true;
  }

  setLoadLine(posicao: boolean): void {
    this.loandTransmissao = posicao;
  }

  Salvar(): void {
    this.dados.iniValid = this.dados.tipo == "E" ? '07/2021' : this.dados.iniValid;

    if (this.Validaform()) {

      this.setLoadLine(true);
      this.utilServico.Post('TabelaRubrica/S1020',
        {
          tipo_xml: this.dados.tipo,
          usuario_id: this.usuario_id,
          db_config: this.db_config,
          iniValid: this.dados.iniValid,
          fimValid: this.dados.fimValid
        }, true
      ).toPromise().then(async (data: any) => {
        if (this.tipo_assinatura === 'A1') {
          await this.transmite.realizarTransmissao(data);
        } else {
          var event = document.createEvent('CustomEvent');
          event.initCustomEvent('EnviarDadosString', true, true, { metodo: 'ExEsocial', xml: data.xml, ambiente: data.Ambiente, retaguarda: data.Retaguarda, ws: this.utilDadosLogado.DadosAcesso().url, tipoenvio: 'N' });
          document.documentElement.dispatchEvent(event);
        }
        this.setLoadLine(false);
        this.dialogRef.close();
      })
        .catch((catchError) => {
          let errorMessage = 'Ocorreu um erro desconhecido.';
          if (catchError._body) {
            try {
              const parsedBody = JSON.parse(catchError._body);
              errorMessage = parsedBody.message || catchError._body;
            } catch (e) {
              errorMessage = "Processo foi interrompido!"
            }
          } else if (catchError.message) {
            errorMessage = catchError.message;
          } else if (catchError.Msg) {
            errorMessage = catchError.Msg;
          } else if (catchError.msg) {
            errorMessage = catchError.msg;
          }
          swal.fire({ title: 'Atenção!', type: 'error', text: errorMessage });
          this.setLoadLine(false);
          this.dialogRef.close();
        });
    }
  }


}
